import React, { useState } from 'react';
import '../styles/Demos.css';

const VIDEOS = [
  {
    id: 'apto-video',
    titulo: 'Apto - Aplicación móvil',
    descripcion:
      'Aplicación móvil orientada a los colaboradores para que puedan ingresar sus tallas de vestuario, ver el estado de sus documentos, registrar su biometría y otras cosas por venir.',
    src: '/uploads/demos/cdv2_mobile.mp4',
    poster: null,
  },
  {
    id: 'apto-control',
    titulo: 'Apto - Control de Documentos',
    descripcion:
      'Demostración del control y expedientes de documentos, gestión de documentos con IA, entrega de ropa de trabajo, mantención de vehículos, etc.',
    src: '/uploads/demos/control-documentosV2.mp4',
    poster: null,
  },
];

function VideoCard({ video, index }) {
  const [loading, setLoading] = useState(true);

  return (
    <article
      className="demo-card"
      style={{ animationDelay: `${index * 120}ms` }}
      aria-labelledby={`${video.id}-title`}
    >
      <div className="demo-card__media">
        {loading && (
          <div className="demo-card__spinner" aria-hidden="true">
            <span className="spinner" />
          </div>
        )}
        <video
          className="demo-card__video"
          src={video.src}
          controls
          preload="metadata"
          playsInline
          onLoadedData={() => setLoading(false)}
          onCanPlay={() => setLoading(false)}
          onError={() => setLoading(false)}
        />
      </div>
      <div className="demo-card__body">
        <h3 id={`${video.id}-title`} className="demo-card__title">
          {video.titulo}
        </h3>
        <p className="demo-card__desc">{video.descripcion}</p>
      </div>
    </article>
  );
}

function Demos() {
  return (
    <div className="demos-page">
      <header className="demos-hero">
        <div className="demos-hero__inner">
          <span className="demos-hero__badge">Demostraciones</span>
          <h1 className="demos-hero__title">
            Conozca el sistema en acción
          </h1>
          <p className="demos-hero__subtitle">
            Videos empotrados que muestran las funcionalidades clave de la
            plataforma de gestión documental.
          </p>
        </div>
      </header>

      <main className="demos-main">
        <section className="demos-grid" aria-label="Lista de videos">
          {[...VIDEOS].reverse().map((video, i) => (
            <VideoCard key={video.id} video={video} index={i} />
          ))}
        </section>
      </main>

      <footer className="demos-footer">
        <p>&copy; {new Date().getFullYear()} Gestión Documental</p>
      </footer>
    </div>
  );
}

export default Demos;
